(function () {
  function parseItemDate(item) {
    var rawValue = (item.dataset.date || '').trim();
    var hasTimezone = /(z|[+-]\d{2}:?\d{2}|gmt[+-]\d{1,2})$/i.test(rawValue);
    var matchedParts;
    var year;
    var month;
    var day;
    var hour;
    var minute;
    var second;
    var itemTime;

    if (!rawValue) {
      return null;
    }

    if (hasTimezone) {
      itemTime = Date.parse(rawValue);
      return Number.isNaN(itemTime) ? null : itemTime;
    }

    matchedParts = rawValue.match(
      /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[ T](\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?)?$/
    );

    if (!matchedParts) {
      itemTime = Date.parse(rawValue);
      return Number.isNaN(itemTime) ? null : itemTime;
    }

    year = Number(matchedParts[1]);
    month = Number(matchedParts[2]) - 1;
    day = Number(matchedParts[3]);
    hour = Number(matchedParts[4] || 0);
    minute = Number(matchedParts[5] || 0);
    second = Number(matchedParts[6] || 0);

    return Date.UTC(year, month, day, hour - 8, minute, second);
  }

  function getActiveIndex(items) {
    var now = Date.now();
    var lastStartedIndex = -1;

    items.forEach(function (item, index) {
      var itemTime = parseItemDate(item);

      if (itemTime === null) {
        return;
      }

      if (itemTime <= now) {
        lastStartedIndex = index;
      }
    });

    if (lastStartedIndex !== -1) {
      return lastStartedIndex;
    }

    return 0;
  }

  function updateTimelineState(items, activeIndex) {
    items.forEach(function (item, index) {
      var isCurrent = index === activeIndex;
      var isPast = index < activeIndex;
      var statusText = item.querySelector('[data-timeline-status]');

      item.classList.toggle('is-current', isCurrent);
      item.classList.toggle('is-past', isPast);
      item.classList.toggle('is-upcoming', index > activeIndex);

      if (isCurrent) {
        item.setAttribute('aria-current', 'step');
      } else {
        item.removeAttribute('aria-current');
      }

      if (statusText) {
        if (isCurrent) {
          statusText.textContent = 'Current event';
        } else if (isPast) {
          statusText.textContent = 'Past event';
        } else {
          statusText.textContent = 'Upcoming event';
        }
      }
    });
  }

  function initTimeline(root) {
    if (!root || root.dataset.musicTimelineInitialized === 'true') {
      return;
    }

    var items = Array.prototype.slice.call(root.querySelectorAll('.music-timeline__item'));

    if (!items.length) {
      return;
    }

    root.dataset.musicTimelineInitialized = 'true';
    updateTimelineState(items, getActiveIndex(items));
  }

  function initAllTimelines(scope) {
    var roots = (scope || document).querySelectorAll('.music-timeline');
    roots.forEach(initTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllTimelines(document);
      },
      { once: true }
    );
  } else {
    initAllTimelines(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) {
      return;
    }

    initAllTimelines(event.target);
  });
})();
